import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class explanationFormModelListTypeAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'ExplanationFormModelListTypes';

  /**
   * Lấy danh sách theo dataType
   * @returns
   */
  async GetDataByListExplanaFormModel(param) {
    const request = {
      url: this.getAPIUrl() + '/explanModelIds',
      data: param,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * lấy dữ liệu theo list ID
   * tvtam 20.6.2024
   */
  async getDataListModelExplanation(param) {
    const request = {
      url: this.getAPIUrl() + `/explanation-model-list`,
      data: param,
    };
    let data = await httpClient.getAsync(request);
    return data;
  }

  /**
 * Lấy danh sách theo dataType
 * @returns
 */
  async getExplanaFormModelListData(param) {
    const request = {
      url: this.getAPIUrl() + '/model-data',
      data: param,
    };
    return await httpClient.postAsync(request);
  }
}

export default new explanationFormModelListTypeAPI();
